import React, { FunctionComponent } from 'react';
import { Block, BlockContent, Typography } from 'components/elements';
import { WPAcfStatistics } from 'types/acf/statistics';
import styles from './Statistics.module.scss';

interface OwnProps {
  data: WPAcfStatistics | null;
}

type StatisticsProps = JSX.IntrinsicElements['div'] & OwnProps;

const Statistics: FunctionComponent<StatisticsProps> = props => {
  const { data } = props;

  if (!data || !data.items) {
    return null;
  }

  const { items = [] } = data;

  return (
    <Block id="statistics" data-module="statistics" theme="dark">
      <BlockContent direction="row">
        {items?.map(({ stat, subheader, header }, index) => (
          <div key={`statistics-item-${index}`} className={styles.wrapper}>
            {header && (
              <Typography align="center" mobile="new_neue_20_h2" as="h3" className={styles.header}>
                {header}
              </Typography>
            )}
            {stat && (
              <Typography align="center" mobile="new_neue_42" as="div" className={styles.stat}>
                {stat}
              </Typography>
            )}
            {subheader && (
              <Typography align="center" mobile="new_neue_20_h2" as="p" className={styles.subheader}>
                {subheader}
              </Typography>
            )}
          </div>
        ))}
      </BlockContent>
    </Block>
  );
};

export default Statistics;
